import React, { useEffect, useState } from 'react'
import { Box, Flex } from 'ui/bend'

// Builder.io dependencies
import { Builder, BuilderComponent, builder } from '@builder.io/react'
import ConnectBanner from '../TrialConnectHub/ConnectBanner'

const BottomBillBoard = ({ ...rest }) => {
  const [heroBillBoard, setHeroBillBoard] = useState(null)

  useEffect(() => {
    builder
      .get('bill-board-sections', {
        userAttributes: {
          urlPath: '/signed-out-hp-bottom-billboard'
        }
      })
      .toPromise()
      .then((heroBillBoardSection) => setHeroBillBoard(heroBillBoardSection))
  }, [])

  return (
    <Flex
      flexDirection={'column'}
      style={{ position: 'relative' }}
      mt={['80px', '100px']}
      mb={['-90px', '-110px']}
    >
      <BuilderComponent model='bill-board-sections' content={heroBillBoard} />
      <ConnectBanner />
    </Flex>
  )
}

export default BottomBillBoard
